import { energyColors } from '@lc/types/Misc';

class AI_Purchase {
	async createPaymentObjectForCost(aiState: any, cost: number = 0) {
		let tempCost = cost;
		const factoryEnergyArr: energyColors[] = [];
		const batteryEnergyArr: energyColors[] = [];
		const carbonReserve: number = 0;

		const paymentObject = {
			factoryEnergyArr,
			batteryEnergyArr,
			carbonReserve,
			paymentPossible: false,
		};

		let FA = aiState.factoryEnergyArr.length;
		let BA = aiState.batteryEnergyArr.length;
		let C = aiState.carbonReserve;

		if (FA + BA + C >= tempCost) {
			paymentObject.paymentPossible = true;

			while (tempCost > 0) {
				if (FA > 0) {
					paymentObject.factoryEnergyArr.push(
						aiState.factoryEnergyArr[FA - 1] || 'y'
					);
					FA--;
					tempCost--;
				} else if (BA > 0) {
					paymentObject.batteryEnergyArr.push(
						aiState.batteryEnergyArr[FA - 1] || 'y'
					);
					BA--;
					tempCost--;
				} else {
					paymentObject.carbonReserve += 1;
					C--;
					tempCost--;
				}
			}
		}

		return paymentObject;
	}

	async createEmptyPaymentObject() {
		const paymentObject = {
			factoryEnergyArr: [],
			batteryEnergyArr: [],
			carbonReserve: 0,
			paymentPossible: true,
		};

		return paymentObject;
	}
}

export const ai_purchase = new AI_Purchase();
